import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Typography } from '@mui/material'
import React from 'react'
import { ChargingPriority } from './ChargingPriority'
import { TrackersBehaviour } from './TrackersBehaviour'

export const ChargingConfiguration: React.FC<{ children: React.ReactNode }> & {
  TrackersBehaviour: typeof TrackersBehaviour
  ChargingPriority: typeof ChargingPriority
} = ({ children }) => {
  const { t } = useCustomTranslation()

  return (
    <>
      <Typography variant="h2" mb={2}>
        {t('installation.storageEditor.chargingConfiguration.title')}
      </Typography>
      {children}
    </>
  )
}

export default ChargingConfiguration

ChargingConfiguration.TrackersBehaviour = TrackersBehaviour
ChargingConfiguration.ChargingPriority = ChargingPriority
